import { useCallback, useContext, useEffect, useState } from "react";
import { HiOutlineStar, HiStar } from "react-icons/hi";
import { MdDelete, MdDownload, MdOutlineMarkEmailRead, MdPrint, MdQrCodeScanner, MdSearch } from "react-icons/md"
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import Modal from "../../Components/Modal";
import Spinner from "../../Components/Spinner";
import Warning from "../../Components/Warning";
import UserContext from "../../Context/UserContext";
import { countExibitorsDocWhereEvent, deleteGuestDoc, getEventsDoc, getExhibitorsDocWhereEvent, getGuestDoc, getGuestsDocWhereEvent, getOrganizerDocs, getStaffDocWhereEmail, getStaffDocsWhereEvents, updateGuestDocStatus, updateGuestDocVip, updateGuestStatus } from "../../Requests/firebaseFirestore";
import { preview, printGuestTag } from "../../Requests/printTag";
import { utils, write } from "xlsx"
import { saveAs } from "file-saver"
import { CgDice3 } from "react-icons/cg";
import AreYouSure from "../../Components/AreYouSure";
import { toPng } from "html-to-image";
import { useRef } from "react";
import { toDataURL } from "qrcode";
import { uploadGuestQrCode } from "../../Requests/firebaseStorage";
import { sendGuestQrCode, vipArrivalMail } from "../../Requests/sendMail";

export default function GuestsPage(){
  const {user, seeAs, url} = useContext(UserContext)
  const navigate = useNavigate()
  
  const [guests, setGuests] = useState([])
  const [guestList, setGuestList] = useState([])

  const [events, setEvents] = useState([])
  const [currentEvent, setCurrentEvent] = useState('no-events')
  
  const [guestToDelete, setGuestToDelete] = useState('')
  const [scannedGuest, setScannedGuest] = useState('')
  const [templateUrl, setTemplateUrl] = useState('')
  const [numWinners, setNumWinners] = useState(1)
  const [winners, setWinners] = useState([])
  const [visitObj, setVisitObj] = useState(0)
  
  const [loading, setLoading] = useState(true)
  const [templateError, setTemplateError] = useState('')
  const [templateWarning, setTemlpateWarning] = useState(false)
  const [search, setSearch] = useState('')
  const [searchType, setSearchType] = useState('all')
  const [tagImage, setTagImage] = useState('')

  const [scanAlert, setScanAlert] = useState('')
  const [scanModal, setScanModal] = useState(false)
  const [forcePrintModal, setForcePrintModal] = useState(false)
  const [tagModal, setTagModal] = useState(false)
  const [giveAwayModal, setGiveAwayModal] = useState(false)
  const [sureModal, setSureModal] = useState(false)
  const [downloadTagModal, setDownloadTagModal] = useState(false)
  
  const ref = useRef(null)

  const {role} = useParams()

  const handleGiveAwayModal = () => {
    setWinners([])
    setGiveAwayModal(!giveAwayModal)
  }
  const reloadGuestList = async (eventId, guests) => {
    setLoading(true)
    if(guests){
      setGuestList([])
      setGuestList([...guests])
    }else{
      if(eventId){

        const res = await getGuestsDocWhereEvent(eventId)
        if(res){
          setGuests(res)
          setGuestList(res)
        }else{
          setGuests([])
          setGuestList([])
        }
      }
    }
    setLoading(false)
  }

  const handleSureModal = async (res, gst) =>{
    if(gst){
      setGuestToDelete(gst)
    }
    if(res==='accepted'){
      await deleteGuestDoc(guestToDelete)
      setGuestToDelete('')
      reloadGuestList(currentEvent.id)
    }
    setSureModal(!sureModal)
  }


  const handleTagModal=()=>{
    setTagModal(!tagModal)
  }

  const handleTemplateWarning = () =>{
    setTemlpateWarning(!templateWarning)
  }

  const getEvents = 
    async () => {
      setLoading(true)
      let res
      switch (role) {
        case 'organizer':
          res = await getEventsDoc()
          break;
        case 'exhibitor':
          if(seeAs===''){
            res = user.events
          }else{
            res = seeAs.events
          }
          break;
        default:
          res = [user.event]
          break;
      }
      setEvents(res)
      if(res.length>0){
        if(currentEvent){
          setCurrentEvent(res[0])
          const exhs = await countExibitorsDocWhereEvent({id:res[0].id, name: res[0].name})
          if(res[0].visitObjective){
            setVisitObj(exhs*(res[0].visitObjective/100))
          }else{
            setVisitObj(exhs*(70/100))
          }
        }
      }else{
        setCurrentEvent('no-events')
      }
      setLoading(false)
    }
  
  const handleEventSelect = async(e) =>{
    setSearch('')
    setSearchType('all')
    const {value} = e.target
    let i
    events.forEach((event, index)=>{
      if(event.id === value){
        i = index
      }
    })
    const exhs = await countExibitorsDocWhereEvent({id:events[i].id, name:events[i].name})
    console.log('num',exhs)
    if(events[i].visitObjective){
      setVisitObj(exhs*(events[i].visitObjective/100))
      console.log(exhs*(events[i].visitObjective/100))
    }else{
      setVisitObj(exhs*(70/100))
    }
    setCurrentEvent(events[i])
  }

  const handleDownloadTagImage = useCallback(async (scannedGuest) => {
    console.log(scannedGuest)
    await updateGuestDocStatus(scannedGuest.id, 'assisted')
    if (ref.current === null) {
      return
    }
    if(scannedGuest.vip){
      await vipArrivalMail(scannedGuest, currentEvent)
    }

    toPng(ref.current, { cacheBust: true, width:'248', height:'360'})
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.download = scannedGuest.name+'-etiqueta.png'
        link.href = dataUrl
        link.click()
      })
      .catch((err) => {
      })
  }, [ref])

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    let filteredList = []

    switch (searchType) {
      case 'vip':
        guests.forEach((guest)=>{
          if(guest.vip){
            filteredList = [...filteredList, guest]
          }
        })
        break;
      case 'novip':
        guests.forEach((guest)=>{
          if(!guest.vip){
            filteredList = [...filteredList, guest]
          }
        })
        break;
      case 'assisted':
        guests.forEach((guest)=>{
          if(guest.status==='assisted'){
            filteredList = [...filteredList, guest]
          }
        })
        break;
      case 'assistednt':
        guests.forEach((guest)=>{
          if(guest.status!=='assisted'){
            filteredList = [...filteredList, guest]
          }
        })
        break;
      case 'visits':
        console.log(currentEvent)
        console.log(visitObj)
        guests.forEach((guest)=>{
          if(guest.visits&&guest.visits.length>visitObj){
            filteredList = [...filteredList, guest]
          }
        })
        break;
      default:
        filteredList = guests
        break;
    }
    let refilteredList = []
    filteredList.forEach((guest)=>{
      if(guest.name.toLowerCase().includes(search.toLowerCase())||guest.company.toLowerCase().includes(search.toLowerCase())){
        refilteredList = [...refilteredList, guest]
      }
    })
    reloadGuestList(currentEvent.id, refilteredList)
  }


  useEffect(()=>{
    reloadGuestList(currentEvent.id)
  },[currentEvent])

  useEffect(()=>{
    const cookies =new Cookies()
    if(cookies.get('tagTemplateUrl')){
      setTemplateUrl(cookies.get('tagTemplateUrl'))
    }
    getEvents()
  },[])

  useEffect(()=>{
    if(role !== 'organizer'){
      navigate(`/${user.role}`)
    }
  },[])

  const handleScanModal = () =>{
    setTemplateError('')
    setTagImage('')
    setScannedGuest({})
    setScanAlert('')

    setScanModal(!scanModal)
  }

  const handleForcePrintModal = (guest)=>{
    setTemplateError('')
    setTagImage('')
    if(forcePrintModal){
      setScannedGuest({})
    }else{
      setScannedGuest(guest)
    }
    setForcePrintModal(!forcePrintModal)
  }

  const handleDownloadTagModal = async (guest) => {
    if(downloadTagModal){
      setScannedGuest({})
    }else{
      try {
        const res = await toDataURL(`${url}/addtogroup/${guest.id}`)
        setScannedGuest({...guest, qrCode: res})
      } catch (error) {
      }
    }
    setDownloadTagModal(!downloadTagModal)
  }

  const setTagText = () => {
    if(scannedGuest.name){
      const getFontSize = (textLength) => {
        const baseSize = 40
        if (textLength >= baseSize) {
          textLength = baseSize - 1
        }
        let fontSize = baseSize - textLength
        if(fontSize<15){
          fontSize = 15
        }
        return `${fontSize}px`
      }
      const text = <><h1 className="font-semibold max-w-[100%] text-adjust" style={{fontSize:getFontSize(scannedGuest.name.length)}}>{scannedGuest.name}</h1>
      <h1 className="font-normal max-w-[100%] text-adjust" style={{fontSize:getFontSize(scannedGuest.position.length)}}>{scannedGuest.position}</h1>
      <h1 className="font-normal max-w-[100%] text-adjust" style={{fontSize:getFontSize(scannedGuest.company.length)}}>{scannedGuest.company}</h1>
      {
        scannedGuest.vip?
        <h1 className="font-semibold">VIP</h1>
        :<></>
      }
      </> 

    return text
}
  }

  const handleVip = async (vipState, guestId, index) => {
    let g = guestList
    g[index].vip = !vipState
    await updateGuestDocVip(guestId, !vipState)
    reloadGuestList(currentEvent.id,g)
  }

  const handleScanSubmit = async (e) => {
    e.preventDefault()
    const res = await getGuestDoc(scannedGuest.id)
    if(res){
      if(res.event === currentEvent.id){
        if(res.status === 'assisted'){
          setScanAlert('El asistente ya fue registrado')
        }
          setScannedGuest({...res, id:scannedGuest.id})
      }else{
        setScanAlert('No se encontró un asistente')
      }
    }else{
      setScanAlert('No se encontró un asistente')
    }
  } 

  const handleScanedGuest = (e) => {
    const {value} = e.target
    setScannedGuest({...scannedGuest, id:value})
  }

  const handleAcceptGuest = async() => {
    if(templateUrl){
      const res = await printGuestTag(scannedGuest, url, templateUrl)
      if(res==='error'){
        setTemplateError('No se ha encontrado el archivo de etiqueta')
      }else{
        setTemplateError('')
        await updateGuestDocStatus(scannedGuest.id, 'assisted')
        if(scannedGuest.vip){
          const res1 = await getExhibitorsDocWhereEvent({id: currentEvent.id, name: currentEvent.name})
          const res2 = await getOrganizerDocs()
          const res3 = await getStaffDocsWhereEvents({id: currentEvent.id, name: currentEvent.name})
          const emails = [...res1.map(e=>e.email), ...res2.map(e=>e.email), ...res3.map(e=>e.email)]
          await vipArrivalMail(scannedGuest, currentEvent, emails)
        }
        reloadGuestList(currentEvent.id)
        setScanModal(false)
        setForcePrintModal(false)  
      }
    }else{
      setScanModal(false)
      setForcePrintModal(false)
      setTemlpateWarning(true)
    }
  }

  const handlePreview = async() => {
    if(templateUrl){
      const res = await preview(scannedGuest, url, templateUrl)
      if(res==='error'){
        setTemplateError('No se ha encontrado el archivo de etiqueta')
      }else{
        setTagImage(res)
      }
    }else{
      setScanModal(false)
      setForcePrintModal(false)
      setTemlpateWarning(true)
    }
  }

  const handleTemplateSubmit = (e) => {
    e.preventDefault()
    const cookies = new Cookies()
    cookies.set('tagTemplateUrl', templateUrl, {path: '/'})
    handleTagModal()
  }

  const handleForceConfirm = async (guest) => {
    try {
      await updateGuestStatus(guest.id)
      const qr = await toDataURL(guest.id)
      const qrUrl = await uploadGuestQrCode(qr, guest.id, guest.event)
      sendGuestQrCode({email:guest.email, event:currentEvent, qrUrl:qrUrl})
      await reloadGuestList(currentEvent.id)
    } catch (error) {
    }
  }

  const handleDownload = () => {
    let toXls = []
    guestList.forEach((gst)=>{
      
      let answers = []
      gst.formAnswers.forEach(ans => {
        if(Array.isArray(ans.answer)){
          answers = {...answers, [ans.question]:ans.answer.join(', ')}
        }else{
          answers = {...answers, [ans.question]:ans.answer}
        }
      })
      let assisted 
      if(gst.status==='assisted'){
        assisted = 'si'
      }else{
        assisted = 'no'
      }
      let vip 
      if(gst.vip){
        vip = 'si'
      }else{
        vip = 'no'
      }
      toXls = [...toXls, {'Nombre completo':gst.name, 'Email':gst.email, 'Teléfono':gst.phone, "Empresa":gst.company, "Localidad":gst.location, "Cargo":gst.position, "Id fiscal":gst.fiscalId, "Permisos":gst.allowShareData, ...answers, 'Asistió':assisted, 'vip':vip}]
 
    })

    const ws = utils.json_to_sheet(toXls)
    const wb = {
      Sheets:{
        'data':ws
      },
      SheetNames:['data']
    }
    const eb = write(wb,{bookType:'xlsx',type:'array'})
    const data = new Blob([eb],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UFT-8'})
    saveAs(data, `ChannelTalks-Asistentes-${currentEvent.name}.xlsx`)
  }

  const handleWinners = (e) => {
    e.preventDefault()
    let indexes = [];
    while(indexes.length < numWinners){
        let num = Math.floor(Math.random() * guestList.length);
        if(indexes.indexOf(num) === -1) indexes.push(num);
    }
    let winners = []
    indexes.forEach(num=>{
      winners = [...winners, guestList[num]]
    })
    setWinners([...winners])
  }

  return(<>
  
  {loading?
  <div className="text-black py-5">
  <Spinner/>
</div>:
  <div className="container mx-auto px-4">
    <div className="flex justify-between my-4">
    <h1 className="text-stone-600 font-semibold text-xl py-2">Asistentes</h1>
    {role==='organizer'?
    <button onClick={handleTagModal} className='action-btn relative'>Configurar etiqueta
     {templateUrl?<></>:
     <>
     <span className="absolute rounded-full  h-5 w-5 bg-red-400 -top-1 -right-1 flex justify-center items-center">
     <span className="absolute rounded-full h-4 w-4 animate-ping bg-red-400"></span>
      </span>
     </>}
      </button>
    :<></>}
    </div>
    {currentEvent!=='no-events'?
    <>
    <div className="table-holder">

    <table className="table-auto min-w-[700px]">
      <thead>
        <tr>
          <th colSpan='100%'>
            <div className="px-5 w-full flex items-center gap-4 justify-between">
              <div className="flex gap-2">
                {role==='organizer'?
                <button className="new-element-button" onClick={handleScanModal}><MdQrCodeScanner size={25}/></button>
                :<></>}
                <button className="light-button" onClick={handleGiveAwayModal}><CgDice3 size={25}/></button>
                <form onSubmit={handleSearchSubmit} className='flex flex-row gap-2' id='search-form'>
                  <input type="text" className="font-normal text-black min-w-[100px]" placeholder="Nombre o empresa" name="search" onChange={e=>{setSearch(e.target.value)}} value={search}/>
                  <select className="font-normal text-black w-[200px]" name="event" id="" onChange={e=>setSearchType(e.target.value)} value={searchType}>
                    <option value='all'>Todos</option>
                    <option value="vip">VIP</option>
                    <option value="novip">No VIP</option>
                    <option value="assisted">Presentes</option>
                    <option value="assistednt">Ausentes</option>
                    {role==='organizer'?
                    <option value="visits">Objetivo de visitas</option>
                    :<></>}
                  </select>
                  <button className="light-button"><MdSearch size={25}/></button>
                </form>
                <span className="flex items-center">Resultados: {guestList.length}</span>
              </div>
              <div className="flex gap-2">
                <select className="font-normal text-black min-w-[100px]" name="event" id="" onChange={handleEventSelect} value={currentEvent.id} form='search-form'>
                  {events.map((event, index)=>{
                    return <option value={event.id} key={index}>{event.name}</option>
                  })}
                </select>
                {role!=='staff'?
                <button className="light-button flex gap-1" onClick={handleDownload}>
                  <MdDownload size={25}/> Descargar
                </button>
                  :<></>}
              </div>
            </div>
          </th>
        </tr>
        <tr className="gap-4">
          {role==='organizer'?
          <th>Acciones</th>
          :<></>}
          <th>Nombre</th>
          <th>Email</th>
          <th>Teléfono</th>
          <th>Empresa</th>
          <th>Localidad</th>
          <th>Confirmó</th>
          <th>Asistió</th>
          <th>VIP</th>
        </tr>
      </thead>
      <tbody>
        {guestList.length===0?
        <tr><td colSpan='100%'><h1>No se encontraron asistentes</h1></td></tr>
        :
        <>
        {guestList.map((guest, index)=>{return(
          <tr key={index}>
            {role==='organizer'?
            <td className="flex flex-wrap gap-1 justify-center px-2 min-w">
            <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{handleForcePrintModal(guest)}}><MdPrint size={25}/></button>
            <button className="action-button border-amber-500 text-amber-500 hover:text-white hover:bg-amber-500 active:bg-amber-700 duration-150" onClick={()=>{handleDownloadTagModal(guest)}}><MdDownload size={25}/></button>
            <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleSureModal('', guest.id); }}><MdDelete size={25}/></button>
            {
              guest.status==='pending'?
              <button className="action-button border-green-500 text-green-500 hover:text-white hover:bg-green-500 active:bg-green-700 duration-150" onClick={()=>{handleForceConfirm(guest) }}><MdOutlineMarkEmailRead size={25}/></button>
              :<></>
            }

            </td>
            :<></>}
            <td>{guest.name}</td>
            <td>{guest.email}</td>
            <td>{guest.phone}</td>
            <td>{guest.company}</td>
            <td>{guest.location}</td>
            <td>{guest.status!=='pending'?'Si':'No'}</td>
            <td>{guest.status==='assisted'?'Si':'No'}</td>
            <td>
              <button className="text-amber-400 flex justify-center items-center" onClick={()=>{handleVip(guest.vip, guest.id, index)}} disabled={role==='organizer'?false:true}>
                {guest.vip?<HiStar size={25}/>:<HiOutlineStar size={25}/>}
              </button>
            </td>
          </tr>
        )})}
        </>}
      </tbody>
    </table>
    </div>

    <Modal isActive={scanModal} handle={handleScanModal} title='Escanear asistente'>
      <div className="flex flex-col gap-4 justify-center">

      <form onSubmit={handleScanSubmit} className="w-[75%] mx-auto">
        <div className="input-holder">
          <input type="text" id="scan-guest" autoFocus onChange={handleScanedGuest} value={scannedGuest.id}/>
          <label htmlFor="scan-guest">Escanea el código</label>
        </div>
      </form>
      {scanAlert!==''?
      <span className="w-[75%] mx-auto text-red-500 font-semibold text-center">{scanAlert}</span>
    :<></>}
      {scannedGuest.name?<>
      <div className="mx-auto w-[75%] bg-stone-100 rounded-[10px] py-2 px-3 ">
        <h1 className="font-semibold text-xl flex items-center">Asistente: 
        {scannedGuest.vip?
        <span className='flex text-md mr-0 ml-auto mt-2 text-amber-400'><HiStar size={25}/></span>
        :<></>}
        </h1>
        <div className="pl-4 divide-y-2 flex flex-col">
          <div className="flex flex-row justify-around py-2">
            <span className="text-left flex-1">Nombre:</span> <span className="flex-1">{scannedGuest.name}</span>
          </div>
          <div className="flex flex-row justify-around py-2">
            <span className="text-left flex-1">Email:</span> <span className="flex-1">{scannedGuest.email}</span>
          </div>
        </div>
      </div>
      <div className="flex justify-center w-[75%] mx-auto">
      <button className="send-btn " onClick={handleAcceptGuest}>Imprimir etiqueta</button>
      <button className="send-btn " onClick={handlePreview}>Visualizar etiqueta</button>
      </div>
      {tagImage!==''?
      <img id='previewArea' src={tagImage} alt="preview" className="w-[250px] mx-auto"/>
      :
      <></>
    }
      </>
      :<></>}
      </div>
    </Modal>
    <Modal isActive={forcePrintModal} handle={handleForcePrintModal} title={'Registro sin QR'}>
      <div className="flex flex-col gap-4 justify-center">
      {templateError?
      <span className="w-[75%] mx-auto text-center border border-[#F03623] py-3 px-3 text-[#F03623] rounded-[10px]">{templateError}</span>:
      <></>}
      <div className="mx-auto w-[75%] bg-stone-100 rounded-[10px] py-2 px-3 ">
        <h1 className="font-semibold text-xl flex items-center">Asistente: 
        {scannedGuest.vip?
        <span className='flex text-md mr-0 ml-auto mt-2 text-amber-400'><HiStar size={25}/></span>
        :<></>}
        </h1>
        <div className="pl-4 divide-y-2 flex flex-col">
          <div className="flex flex-row justify-around py-2">
            <span className="text-left flex-1">Nombre:</span> <span className="flex-1">{scannedGuest.name}</span>
          </div>
          <div className="flex flex-row justify-around py-2">
            <span className="text-left flex-1">Empresa:</span> <span className="flex-1">{scannedGuest.company}</span>
          </div>
          <div className="flex flex-row justify-around py-2">
            <span className="text-left flex-1">Cargo:</span> <span className="flex-1">{scannedGuest.position}</span>
          </div>
        </div>
      </div>
      <div className="flex justify-center w-[75%] mx-auto">
      <button className="send-btn " onClick={handleAcceptGuest}>Imprimir etiqueta</button>
      <button className="send-btn " onClick={handlePreview}>Visualizar etiqueta</button>
      </div>
      {tagImage !==''?
      <div className="mx-auto w-fit">
        
      <a href={tagImage} download={`${scannedGuest.name}.png`}>
      <img id='previewArea' src={tagImage} alt="preview" className="w-[250px] mx-auto"/>
      </a>
      </div>
      :
      <></>
    }
      </div>
    </Modal>
    <Modal isActive={tagModal} handle={handleTagModal} title='Configurar etiqueta'>
      <div className="flex flex-col gap-4">
          {templateUrl?<></>:
          <span className="w-[75%] mx-auto text-center">No se especificó ningún archivo para las etiquetas</span>}
      <a 
      href="https://firebasestorage.googleapis.com/v0/b/channel-talks-web.appspot.com/o/defaultFiles%2FMyTemplate.lbx?alt=media&token=62a7b4a6-9355-4375-a443-9bba362948ac"
      download='template.blx'
      className="action-btn mx-auto">
        descargar archivo .lbx
      </a>
      <form className="flex flex-col gap-4 justify-center" onSubmit={handleTemplateSubmit}>
      <div className="input-holder w-[50%]">
        <input type="text" id="tag-template-path" onChange={(e)=>{setTemplateUrl(e.target.value)}} value={templateUrl} required/>
        <label htmlFor="tag-template-path">Direccion de archivo</label>
      </div>
          <button className="send-btn">Guardar</button>
      </form>
        </div>
    </Modal>
    <Warning isActive={templateWarning} handle={handleTemplateWarning} title='No se especificó un archivo para las etiquetas'></Warning>
    <Modal isActive={giveAwayModal} handle={handleGiveAwayModal} title='Sortear asistentes'>
      {search===''&&searchType==='all'?<></>:<span className="text-center block mx-auto my-3">se aplicaran los filtros establecidos</span>}
      <form className="flex flex-col gap-4" onSubmit={handleWinners}>
      <div className="flex w-[75%] mx-auto items-center gap-2 justify-center">
        <label htmlFor="number-of-winners">Cantidad de ganadores:</label>
        <input type="number" id="number-of-winners" className="w-[100px]" min={1} max={guestList.length} value={numWinners} onChange={(e)=>{setNumWinners(e.target.value)}}/>
      </div>
      <button className="send-btn">Sortear</button>
      </form>
      {winners.length!==0?<>
      <div className="flex flex-col gap-4 w-[75%] mx-auto">
      <h1 className="text-xl font-semibold">Ganadores:</h1>
      {winners.map((winner, index)=>{return(
        <div key={index} className='flex gap-2 items-center text-xl'>
          <span>{index+1}.</span><span className="text-xl">{winner.name}, {winner.company}</span>
        </div>
      )})}
      </div>
      </>:<></>}
    </Modal>
    <Modal isActive={downloadTagModal} handle={handleDownloadTagModal} title='Descargar imagen de etiqueta'>
      <div className="flex flex-col justify-center">
        <div className="block mx-auto">
        <div ref={ref} className='bg-white flex flex-col justify-center items-center text-center arial w-[248px] h-[360px]'>
          <img src={scannedGuest.qrCode} alt="qrcode" />
          {setTagText()}
        </div>
        </div>
        <button className="send-btn mx-auto block mt-3" onClick={()=>{handleDownloadTagImage(scannedGuest)}}>Descargar</button>
      </div>
    </Modal>
    <AreYouSure isActive={sureModal} handle={handleSureModal} title='¿Eliminar asistente?'/>
    </>
    :
    <h1>Crea un evento para empezar a registrar asistentes</h1>}
  </div>
}
  </>
  
  )
}